import React, { Component } from 'react';
import './index.less';

class TextShow extends Component {

    constructor() {
        super();

        this.state = {
            openPullDown: false
        };
    }

    togglePullDown = (e) => {
        e.stopPropagation();
        e.preventDefault();

        this.setState({
            openPullDown: !this.state.openPullDown
        });
    }

    render() {
        const { content, length: limitLen, } = this.props;
        const classnames = 'textShow';
        let showText = '';
        if (content.length > limitLen) {
            let str1 = content.substring(0, limitLen);
            let str2 = content.substring(limitLen);
            let str3 = (<a className={classnames} onClick={e => this.togglePullDown(e)}>
                {this.state.openPullDown ? window.language['common.collapse'] : "..."+window.language['common.expand']}
            </a>);
            if(this.state.openPullDown){
                showText = <span>{str1}{str2}{str3}</span>;
            }else{
                showText = <span>{str1}{str3}</span>;
            }                        
        } else {
            showText = content;
        }

        return (
            <div>
                {showText}
            </div>
        );
    }
}

export default TextShow;


// WEBPACK FOOTER //
// ./src/components/TextShow/TextShow.js